import React from "react"
import { ACCESS_EMBEDDED_URL } from "constants/urls"
import { usePageAssets } from "hooks/usePageAssets"
import Button from "components/ui/Button"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import SplitContainer from "components/ui/Layout/SplitContainer"

function HeroSection() {
  const { getAsset } = usePageAssets()
  const illustration = getAsset("customer-apps-hero-background")
  return (
    <Container section>
      <SplitContainer
        className="mt-10 lg:mt-0 lg:py-10 xl:py-20"
        image={illustration}
        imageSize="large"
        imageClassName="scale-150 md:scale-110 lg:scale-110 xl:scale-100 lg:translate-x-[20%] xl:translate-x-[15%] 2xl:translate-x-[20%] mt-[20%] md:mt-0 lg:mt-[5%]"
      >
        <Heading
          level="h1"
          title="Embed interactive dashboards that feel like your product"
          subtitle={
            <>
              Easily integrate and embed analytics directly inside of your
              application, product, or service.
            </>
          }
          size="huge"
          narrow
        />
        <Button
          className="mt-7"
          color="green"
          size="medium"
          href={ACCESS_EMBEDDED_URL}
          trackClick="Request Access (hero)_Use Cases - Customer Apps"
          shadow
        >
          Request Access
        </Button>
      </SplitContainer>
    </Container>
  )
}

export default HeroSection
